module.exports = __webpack_public_path__ + "static/media/skill4_neg_es.a6e7e366.txt";